import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IToggleRTMPlanRes } from './index.type';

const useDeleteRTMPlan = ({ RTMPlanId }: { RTMPlanId?: string }) => {
  const { loading: deleteRTMPlanLoading, makeApiCall } = useApi({
    // url: `/RTM/rtm-plan/delete/${RTMPlanId}`,
     url:`/rtm/plan/${RTMPlanId}`,
    method: 'PATCH',
  });

  const deleteRTMPlan = async () => {
    const { response, error } = await makeApiCall<undefined, IToggleRTMPlanRes>();

    if (response?.status === 'success') {
      toast.success('RTM Plan deleted successfully.');
      return { status: response.status };
    }

    if (error) {
      toast.error('Something went wrong whiling deleting  RTM Plan. Please try again later');
      return { status: 'fail' };
    }
  };

  return {
    deleteRTMPlanLoading,
    deleteRTMPlan,
  };
};

export default useDeleteRTMPlan;
